import { render, staticRenderFns } from "./KwicHeader.vue?vue&type=template&id=7bbec584&"
import script from "./KwicHeader.vue?vue&type=script&lang=js&"
export * from "./KwicHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports